interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  bgColor?: 'white' | 'sand' | 'olive' | 'dark';
}

export default function Section({ 
  children, 
  className = '', 
  id,
  bgColor = 'white' 
}: SectionProps) {
  const bgStyles = {
    white: 'bg-white',
    sand: 'bg-sand-100',
    olive: 'bg-olive-50',
    dark: 'bg-earth-800 text-sand-100',
  };

  return (
    <section id={id} className={`section-padding ${bgStyles[bgColor]} ${className}`}>
      <div className="container-custom">
        {children}
      </div>
    </section>
  );
}
